module.exports = __webpack_public_path__ + "static/media/logo_dongabank.2f696516.svg";